import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import {  SelectField, SmallBodyText } from '../../../../../ui-toolkit';
import React from 'react';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';
import { DisplayLoanType } from '../../../../../ui-toolkit/orders/interfaces/eLoanType';

export const LoanType: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'Loan Type'}
      tab={`other`}
      field={`loan_type`}
      onUpdate={(_, value) => onPatchOrderInformation({ loanType: value ?? null })}
      order={order}
      editControl={SelectField}
      editProps={{ options: optionsFromDisplay(DisplayLoanType), isClearable: true }}
    >
      {order.transaction.loan_type ? (
        DisplayLoanType[order.transaction.loan_type]
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
